import { useEffect, useRef, useState } from 'react';
export const useContentHeight = (visible) => {
    const [isContentTallerThanViewport, setIsContentTallerThanViewport] = useState(false);
    const contentRef = useRef(null);
    useEffect(() => {
        if (!visible) {
            setIsContentTallerThanViewport(false);
            return;
        }
        const checkHeight = () => {
            if (contentRef.current) {
                const contentHeight = contentRef.current.scrollHeight;
                const viewportHeight = window.innerHeight;
                setIsContentTallerThanViewport(contentHeight > viewportHeight);
            }
        };
        // Initial check after render
        const timeoutId = setTimeout(checkHeight, 50);
        // Listen to resize events
        window.addEventListener('resize', checkHeight);
        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener('resize', checkHeight);
        };
    }, [visible]);
    return { isContentTallerThanViewport, contentRef };
};
